import { useAtomValue } from 'jotai';

import { Divider,Group, SkeletonRect, Stack } from '@ekhodealer/ekho-common/rev';

import { useGetLeadDetails } from '@common/api/leads/useGetLeadDetails';

import { leadDetailsDrawerAtom } from '../../atoms/leadDetailsDrawerAtoms';

import { AbandonedCartsSection } from './AbandonedCartsSection';
import { ContactInfoSection } from './ContactInfoSection';
import { PreQualificationsSection } from './PreQualificationsSection';
import { RejectedFinancingSection } from './RejectedFinancingSection';
import { SummarySection } from './SummarySection';

const OverviewTabContentSkeleton = () => {
	return (
		<Stack itemsSpacing='16'>
			{/* Summary Section Skeleton */}
			<Stack itemsSpacing='16'>
				<Group itemsSpacing='12' noWrap itemsAlignX='stretch'>
					<SkeletonRect width='100%' height='73px' />
					<SkeletonRect width='100%' height='73px' />
					<SkeletonRect width='100%' height='73px' />
				</Group>
				<SkeletonRect width='100%' height='142px' />
			</Stack>
			{/* Section skeletons */}
			<Stack itemsSpacing='16'>
				{Array.from({ length: 5 }).map((_, idx) => (
					<>
						<Group key={idx}>
							<SkeletonRect width='30%' height='32px' />
							<SkeletonRect width='32px' height='32px' />
						</Group>
						{idx < 4 && <Divider />}
					</>
				))}
			</Stack>
		</Stack>
	);
};

/**
 * Overview tab content for lead details drawer
 * Displays various sections related to the lead's activity and information
 * Each section includes its own divider that hides when the section is hidden
 * Loading state is managed at this level - shows skeleton while fetching lead details
 */
export const OverviewTabContent = () => {
	const { selectedRow } = useAtomValue(leadDetailsDrawerAtom);
	const { isLoading } = useGetLeadDetails(selectedRow?.id);

	if (!selectedRow) {
		return null;
	}

	if (isLoading) {
		return <OverviewTabContentSkeleton />;
	}

	return (
		<Stack>
			<SummarySection />
			<ContactInfoSection />
			<PreQualificationsSection />
			<AbandonedCartsSection />
			<RejectedFinancingSection />
		</Stack>
	);
};
